/**
 * 交易票信息
 */
import React from 'react';

import { Row, Col, DatePicker, Button, Input } from 'antd';

import PageLayout from '../../ui/PageLayout';
import moment from 'moment';

import http from '../../../axios/http';
import Loading from '../../ui/Loading';
import OrgSelect from '../../ui/OrgSelect';

class TradeTicketIndex extends React.Component {

    columns = [{
        title: '办理时间',
        dataIndex: 'billingTime',
        width: '10%',
    }, {
        title: '国税票号',
        dataIndex: 'invoiceNo',
        width: '7%',
    }, {
        title: '经纪公司',
        dataIndex: 'agency',
        width: '13%',
    }, {
        title: '车辆类型',
        dataIndex: 'vehicleType',
        width: '10%',
    }, {
        title: '车架号',
        dataIndex: 'vin',
        width: '15%',
    }, {
        title: '车辆价格',
        dataIndex: 'amount',
        width: '7%',
    }, {
        title: '服务类型',
        dataIndex: 'transferType',
        width: '7%',
    }, {
        title: '服务费',
        dataIndex: 'commission',
        width: '5%',
    }, {
        title: '状态',
        dataIndex: 'state',
        width: '5%',
        format: { "1": "已开票", "2": "已作废" },
    }, {
        title: '备注',
        dataIndex: 'remark',
        width: '15%',
    }];

    state = {
        loadData: '',
        queryData: {
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
        },
        showLoding: false,

    };

    rangePickerChange = (dates, dateStrings) => {
        let queryData = this.state.queryData;
        queryData.startDate = dateStrings[0];
        queryData.endDate = dateStrings[1];
        this.setState({ queryData: queryData });
        this.state.loadData(queryData);
    }

    inputSearch = (value) => {
        let queryData = this.state.queryData;
        queryData.agency = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }

    //所属市场查询
    orgSelect = (value) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        this.setState({ queryData: queryData });
        this.state.loadData(queryData)
    }


    //导出
    download = () => {
        let queryData = this.state.queryData;
        this.setState({ showLoding: true });
        let fileName = queryData.startDate + "~" + queryData.endDate + " trade ticket.xlsx";
        http.download({
            url: '/tradeTicket/downloadTradeTicket',
            data: queryData,
            fileName: fileName,
            success: (res) => {
                this.setState({ showLoding: false });
            }
        });
    }


    render() {
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <PageLayout
                    condition={(
                        <Row>
                            <Col span={20}>
                                <Input.Search
                                    placeholder="开票公司"
                                    onSearch={this.inputSearch}
                                    style={{width: 250, marginRight: '10px'}}
                                    enterButton
                                />
                                <DatePicker.RangePicker
                                    defaultValue={[moment(), moment()]}
                                    allowClear={false}
                                    onChange={this.rangePickerChange} />

                                <OrgSelect style={{ width: '200px', marginLeft: '10px' }} 
                                    onChange={this.orgSelect}
                                    allowClear={true}
                                    orgType={4}
                                    treeDefaultExpandAll={true} />
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Button type="primary" onClick={this.download}>导出</Button>
                            </Col>
                        </Row>
                    )}
                    rowKey="id" url="/tradeTicket/findTicketPage" columns={this.columns}
                    initParams={this.state.queryData}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                />
                <Loading visible={this.state.showLoding} message="正在导出，请稍候..." />
            </div>
        )
    }
}

export default TradeTicketIndex;